import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 12px 24px;
  color: #585858;
  text-transform: capitalize;
  font-weight: 500;
  line-height: 20px;
`;
